import type { ReviewOverviewTypes } from '@ramp106/omrjs-reviews-ui'

import type { ReviewsAgencyUniversalReviewQuery } from '@/gql/reviews'

type UniversalReviewDetail = NonNullable<ReviewsAgencyUniversalReviewQuery['manage']>['universalReview']

export type AgencyReviewCard = {
  overview: ReviewOverviewTypes.Review
  statement: string | null
}

export const mapUniversalReviewToCardProps = (review: UniversalReviewDetail, agencyTitle: string): AgencyReviewCard => ({
  overview: {
    anonymous: review.anonymous,
    companyField: review.companyField,
    companyName: review.companyName,
    companyPosition: review.companyPosition,
    companySize: review.companySize,
    id: review.id,
    product: { title: agencyTitle },
    publishedAt: review.publishedAt ?? review.firstPublishedAt ?? review.createdAt,
    recommendationScore: review.npsScore,
    reviewerFirstName: review.reviewerName?.split(' ')[0] || null,
    title: review.title,
  },
  statement: review.statement ?? null,
})
